export default __webpack_public_path__ + "static/media/023-twitter-1.03bb06db.svg";